import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "predictive-search-result-product",
  class PredictiveSearchResultProduct extends WYATTElement {
    constructor() {
      super();

      this.data = JSON.parse(this.dataset.result);

      this.innerHTML = `<product-summary data-tabindex="-1" data-handle="${this.data.handle}"></product-summary>`;

      this.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick() {
      if (
        !IntelliSuggest ||
        !this.data.intellisuggestData ||
        !this.data.intellisuggestSignature
      ) {
        return;
      }

      IntelliSuggest.clickItem(this, {
        siteId: WYATT.config.searchspring.siteIds.products,
        intellisuggestData: this.data.intellisuggestData,
        intellisuggestSignature: this.data.intellisuggestSignature,
      });
    }
  },
);
